import {
  CALENDAR_SET_VIEW,
  CALENDAR_SET_DATE,
  CALENDAR_SET_SELECTED_AGENDAS,
  CALENDAR_SET_FILTERS,
  CALENDAR_SET_LOADING,
  CALENDAR_SET_ERROR,
  CALENDAR_CLEAR_ERROR,
  CALENDAR_VIEWS
} from './calendarTypes.js';

export const setView = (view) => ({
  type: CALENDAR_SET_VIEW,
  payload: view
});

export const setDate = (date) => ({
  type: CALENDAR_SET_DATE,
  payload: date
});

export const setSelectedAgendas = (agendas) => ({
  type: CALENDAR_SET_SELECTED_AGENDAS,
  payload: agendas
});

export const setFilters = (filters) => ({
  type: CALENDAR_SET_FILTERS,
  payload: filters
});

export const setLoading = (loading) => ({
  type: CALENDAR_SET_LOADING,
  payload: loading
});

export const setError = (error) => ({
  type: CALENDAR_SET_ERROR,
  payload: error
});

export const clearError = () => ({
  type: CALENDAR_CLEAR_ERROR
});

export const navigateToDate = (date) => (dispatch) => {
  dispatch(setDate(date));
};

export const changeView = (view) => (dispatch) => {
  dispatch(setView(view));
};

export const toggleAgenda = (agendaId) => (dispatch, getState) => {
  const { selectedAgendas } = getState().calendar;
  const newSelectedAgendas = selectedAgendas.includes(agendaId)
    ? selectedAgendas.filter(id => id !== agendaId)
    : [...selectedAgendas, agendaId];
  
  dispatch(setSelectedAgendas(newSelectedAgendas));
};

export const updateFilters = (newFilters) => (dispatch, getState) => {
  const { filters } = getState().calendar;
  dispatch(setFilters({ ...filters, ...newFilters }));
};